module.exports = __webpack_public_path__ + "img/20191010171131666.daaa3d61.jpg";